import React from 'react'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { Route, Switch } from 'react-router-dom'

import { CumulativeQuarterlyReviewRouteCostAnalysisViewIndex } from '../../views/ReportsCumulativeQuarterlyReviewRouteCostAnalysis'
import Header from './Header'
import './styles.scss'

export default class ReportsCumulativeQuarterlyReviewRouteCostAnalysisLayout extends React.PureComponent {
  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12}>
            <Header />
          </Col>
        </Row>
        <Switch>
          <Route
            component={CumulativeQuarterlyReviewRouteCostAnalysisViewIndex}
          />
        </Switch>
      </Grid>
    )
  }
}
